const sentPurchases = new Set();
const fields = ['tour_id', 'tour_name', 'plan_id', 'plan_name', 'selected_date', 'adults', 'children', 'value', 'currency'];

export function track(event, parameters = {}, ecommerce) {
    try {
        window.dataLayer = window.dataLayer || [];
        // Clear optional values so GTM never inherits another tour's selection.
        const payload = Object.fromEntries(fields.map(key => [key, parameters[key] ?? null]));
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event, ...parameters, ...payload, ...(ecommerce ? { ecommerce } : {}) });
        return true;
    } catch (_) {
        return false; // Analytics must never interrupt booking.
    }
}

export function tourParameters(tour) {
    return { tour_id: String(tour.id ?? tour.tour_id ?? tour.rezdy_id), tour_name: tour.title || tour.name };
}

export function rememberSelection(productCode, parameters, startTimeLocal) {
    try {
        const selections = JSON.parse(sessionStorage.getItem('booking_analytics') || '{}');
        selections[startTimeLocal ? JSON.stringify([productCode, startTimeLocal]) : productCode] = parameters;
        sessionStorage.setItem('booking_analytics', JSON.stringify(selections));
    } catch (_) { /* Storage may be unavailable. */ }
}

export function bookingEcommerce(booking) {
    let selections = {};
    try { selections = JSON.parse(sessionStorage.getItem('booking_analytics') || '{}'); } catch (_) { /* Optional. */ }
    return {
        value: Number(booking.totalAmount),
        currency: booking.totalCurrency || 'AUD',
        items: (booking.items || []).map(item => {
            const selection = selections[JSON.stringify([item.productCode, item.startTimeLocal])] || selections[item.productCode] || {};
            const quantity = Number(item.totalQuantity) || 1;
            return {
                tour_id: selection.tour_id,
                tour_name: selection.tour_name,
                plan_id: selection.plan_id,
                plan_name: selection.plan_name,
                adults: selection.adults,
                children: selection.children,
                item_id: selection.tour_id || item.productCode,
                item_name: selection.tour_name || item.productName,
                item_variant: selection.plan_id,
                item_category: selection.plan_name,
                selected_date: item.startTimeLocal?.slice(0, 10),
                price: Number(item.subtotal) / quantity,
                quantity
            };
        })
    };
}

export function trackPurchase(booking) {
    if (!booking || !['CONFIRMED', 'PENDING_SUPPLIER'].includes(booking.status) || !booking.orderNumber || !booking.items?.length) return false;
    const id = String(booking.orderNumber);
    const key = `ga4_purchase:${id}`;
    if (sentPurchases.has(id)) return false;
    try { if (localStorage.getItem(key)) return false; } catch (_) { /* Memory fallback. */ }
    const ecommerce = { ...bookingEcommerce(booking), transaction_id: id };
    if (!Number.isFinite(ecommerce.value) || ecommerce.value < 0) return false;
    if (!track('purchase', { value: ecommerce.value, currency: ecommerce.currency }, ecommerce)) return false;
    sentPurchases.add(id);
    try { localStorage.setItem(key, '1'); } catch (_) { /* GA4 also deduplicates transaction IDs. */ }
    return true;
}
